<script setup>
import { ref, defineProps, computed, inject } from 'vue';
import IntroPage from '@/components/result/IntroPage.vue';

const props = defineProps({
    schoolType: {
        type: String, 
        required: true
    }
});

// 부모에서 제공하는 데이터 주입
const schoolData = inject('schoolData');

const reportData = computed(() => {
    console.log("schoolType:", props.schoolType);
    console.log("schoolData in Page1:", schoolData.value);
    
    // API 데이터가 있으면 사용
    if (schoolData.value && schoolData.value.classList && schoolData.value.classList.length > 0) {
        const schoolInfo = schoolData.value.classList[0];
        
        // classList에서 모든 grade_code를 수집 (중복 제거)
        const grades = [...new Set(schoolData.value.classList.map(item => item.grade_code))].filter(Boolean);
        
        // schoolType에 따른 reportSchoolType 매핑
        let reportSchoolType = props.schoolType;
        if (props.schoolType === 'secondary') {
            // API의 schul_type에 따라 middle 또는 high로 세분화
            if (schoolInfo.schul_type === 'M') {
                reportSchoolType = 'middle';
            } else if (schoolInfo.schul_type === 'H') {
                reportSchoolType = 'high';
            }
        }
        
        return {
            region: "서울",
            schoolName: schoolInfo.schul_nm || "학교",
            grade: grades,     
            className: "",  
            studentNumber: "", 
            gender: "",     
            studentName: "",
            reportSchoolType: reportSchoolType
        };
    }

    // 기본값 (API 데이터가 없을 때)
    console.log("API 데이터 없음, 기본값 사용");
    if (props.schoolType === 'elementary') {
        return {
            region: "서울",
            schoolName: "늘푸른초등학교",
            grade: "4",     
            className: "1",  
            studentNumber: "1", 
            gender: "남",     
            studentName: "홍길동",
            reportSchoolType: props.schoolType 
        };
    } else if (props.schoolType === 'secondary') {
        return {
            region: "서울",
            schoolName: "늘푸른중학교",
            grade: "2",     
            className: "1",  
            studentNumber: "1", 
            gender: "남",     
            studentName: "홍길동",
            reportSchoolType: 'middle' // 기본값으로 middle 사용
        };
    } else {
        return {
            region: "미정",
            schoolName: "알수없는학교",
            grade: "",     
            className: "",  
            studentNumber: "", 
            gender: "",     
            studentName: "",
            reportSchoolType: ''
        };
    }
});
</script>
<template>
    <div class="slide-inner pt-[50px]"> 
        <IntroPage reportType="principal" :reportData="reportData" />
    </div>
</template>
